<app-main-sidebar>
  <div class="full-width">
    <div class="app-header horizontal seperate bottom">
      @if (pageTitle || pageDescription) {
        <div class="vertical">
          @if (pageTitle) {
            <div class="page-title">{{ pageTitle }}</div>
          }
          @if (pageDescription) {
            <div class="description">{{ pageDescription }}</div>
          }
        </div>
      }
      <ng-content select=".header-left"></ng-content>
      <ng-content select=".header-right"></ng-content>
    </div>
    @if (getTrialMessage() && !isPricingPage()) {
      <nz-alert nzType="info" [nzMessage]="getTrialMessage()" nzShowIcon [nzAction]="actionTemplate4"></nz-alert>

      <ng-template #actionTemplate4>
        <div class="horizontal">
          <button nz-button nzSize="small" nzType="default" (click)="onUpgradeClick()">Upgrade</button>
          <button nz-button nzSize="small" nzType="primary" (click)="onBookDemoClick()">Book a Demo</button>
        </div>
      </ng-template>
    }

    <div class="app-body vertical-large top">
      <ng-content></ng-content>
    </div>
  </div>
</app-main-sidebar>

<app-content-modal
  [(isVisible)]="isExpired"
  [closable]="false"
  [title]="'Your trial has expired.'"
  [content]="'Please subscribe to continue using Peak Mojo.'"
  [okText]="'Subscribe'"
  (okClick)="onUpgradeClick()"
  [cancelText]="'Switch Workspaces'"
  (cancelClick)="onSwitchWorkspaceClick()"
></app-content-modal>
